export const removeHash = (text: string): string => {
  let formatedText = text;
  if (text.indexOf("#") !== -1) {
    formatedText = text.replace(/#/g, "");
  }
  return formatedText;
};

export const removeSpecialCharacters = (text: string): string => {
  const formatedText = text.replace(/[-[/\]{}()*+?.,\\^$|#\s]/g, "");
  return formatedText;
};

export const allowSpecialCharacters = (text: string): string => {
  const formatedText = text.replace(/[^a-zA-Z0-9 ]/g, "");
  return formatedText;
};
